import { LogLevel, Configuration } from '@azure/msal-browser';

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_DEMO_HELP_CENTRE_SIGN_IN',
  },
  authorities: {
    signUpSignIn: {
      authority:
        'https://authbeta.b2clogin.com/authbeta.onmicrosoft.com/B2C_1_DEMO_HELP_CENTRE_SIGN_IN',
    },
  },
  authorityDomain: 'authbeta.b2clogin.com',
};

export const msalConfig: Configuration = {
  auth: {
    clientId: '69880f69-da23-4e8d-b4f5-8d37206716d6',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // "sessionStorage" is more secure, "localStorage" enables SSO
    storeAuthStateInCookie: false, // Enable for compatibility with IE11/Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line
            console.error(message);
            break;
          case LogLevel.Info:
            // eslint-disable-next-line
            console.info(message);
            break;
          case LogLevel.Verbose:
            // eslint-disable-next-line
            console.debug(message);
            break;
          case LogLevel.Warning:
            // eslint-disable-next-line
            console.warn(message);
            break;
          default:
            // Handle unexpected log levels
            // eslint-disable-next-line
            console.warn(`Unknown log level: ${level}`);
            break;
        }
      },
    },
    // Increase iframe timeout to handle slow networks better
    iframeHashTimeout: 6000, // 6 seconds (default is 5 seconds)
    windowHashTimeout: 6000, // 6 seconds (default is 5 seconds)
  },
};

export const loginRequest: { scopes: string[] } = {
  scopes: ['openid', 'offline_access'],
};
/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest: { scopes: string[]; loginHint?: string } = {
//   scopes: ["openid", "profile"],
//   loginHint: "example@domain.net",
// };
